// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32i_G","title":"styles_title__Mi3CD"};